import { z } from 'zod'

export const ConfigurationCallGatewayZod = z.object({
  enabled: z.boolean().nullish().default(false),
  phoneNumber: z.string().nullish(),
  voices: z
    .object({
      fr: z.string().default('AWS.Polly.Gabrielle-Neural'),
      en: z.string().default('AWS.Polly.Joanna-Neural'),
    })
    .nullish()
    .default({}),
})
